import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import DeniedPanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';

import { getStore } from '../../../../common/redux/store-utils';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const store = getStore();

const createDeniedScreen = () => {
  const root = createRoot(document.getElementById('deniedPanel'));
  if (isSupportedBrowser()) {
    root.render(
      <Provider store={store}>
        <AuthScreenLayout>
          <DeniedPanel />
        </AuthScreenLayout>
      </Provider>
    );
  } else {
    root.render(<UnsupportedBrowsers />);
  }
};

window.createDeniedScreen = createDeniedScreen;
